import type { MigrationStrategies } from 'rxdb';
import type { NotificationDocument } from './notification.types';

export const notificationMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: NotificationDocument) => ({ ...oldDoc, isActive: true, alertMetaData: '' }),
};
